import { z } from "zod";

export const RequestFormFieldDataInputSchema = z.object({
    requestTypeId: z.number(),
    requestId: z.string().uuid().nullable().default(null),
    includeServerSideInfo: z.boolean().nullish().default(null),
    userName: z.string().nullish().default(null),
    clientId: z.string().nullish().default(null),
    showRemovedParameterTypes: z.boolean().default(false),
});

export type RequestFormFieldDataInput = z.infer<typeof RequestFormFieldDataInputSchema>;
